import React, { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, Grid, TextField, Typography } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const AgentGoalSection = ({
  agent,
  onChange,
  onCommit = null,
  onInstructionsCommit = null,
  saveStatus = null,
  locked = false,
}) => {
  const [editingInstructions, setEditingInstructions] = useState(false);

  useEffect(() => {
    if (locked) setEditingInstructions(false);
  }, [locked]);

  const handleNameBlur = () => {
    if (typeof onCommit === "function") onCommit();
  };

  const handleStartEditInstructions = () => {
    if (locked) return;
    setEditingInstructions(true);
  };

  const handleSaveInstructions = () => {
    setEditingInstructions(false);
    if (typeof onInstructionsCommit === "function") onInstructionsCommit();
    else if (typeof onCommit === "function") onCommit();
  };

  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="baseline" justifyContent="space-between" flexWrap="wrap" style={{ gap: 8 }}>
          <Typography variant="h6" gutterBottom style={{ marginBottom: 0 }}>
            Instructions
          </Typography>
          {saveStatus ? (
            <Typography variant="caption" color="textSecondary">
              {saveStatus}
            </Typography>
          ) : null}
        </Box>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 4, marginBottom: 12 }}>
          Click Edit to change instructions, then Save when you are done. Nothing is written
          until you click Save. A material Save (wording or numbers — not just spaces, newlines,
          or bullets) refreshes watches, rules, and actions via AI Copilot — existing tools are
          kept; new ones are only added when needed.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Agent name"
              variant="outlined"
              value={agent.name || ""}
              onChange={(event) => onChange({ name: event.target.value })}
              onBlur={handleNameBlur}
              disabled={locked}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={6}
              rowsMax={12}
              label="Instructions to the Agent"
              variant="outlined"
              value={agent.goal || ""}
              onChange={(event) => onChange({ goal: event.target.value })}
              disabled={locked}
              InputProps={{
                readOnly: !editingInstructions,
              }}
              placeholder="Describe exactly what this agent should monitor, decide, and do."
              inputProps={{
                style: {
                  maxHeight: 320,
                  overflowY: "auto",
                  cursor: editingInstructions ? "text" : "default",
                },
              }}
            />
            <Box display="flex" justifyContent="flex-end" mt={1}>
              {editingInstructions ? (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleSaveInstructions}
                  disabled={locked}
                >
                  Save
                </Button>
              ) : (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  startIcon={<EditOutlinedIcon fontSize="small" />}
                  onClick={handleStartEditInstructions}
                  disabled={locked}
                >
                  Edit
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AgentGoalSection;
